/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：831
 */

var r = require(/* 1240 */"./1240")
var o = require(/* 1081 */"./1081")
module.exports = Object.keys || function (e) {
  return r(e, o)
}
